import * as yup from "yup";
import { initializeYup } from "@duosoftbg/nacid-components";

export const createCategoryValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};
